import { Flex } from 'lib/components/styles/layout';
import styled, { css } from 'styled-components/macro';
import { SidebarItemProps } from './components/modal/LandingPageBuilderModal';

export const LandingPageDesignCardWrapper = styled.div`
  box-sizing: border-box;
  max-width: 320px;
  height: 526px;
  border-radius: 8px;
  padding: 20px 20px 11px 20px;
  background: ${props => props.theme.colors.white[100]};
  border: 1px solid ${props => props.theme.colors.neutral[20]};
  box-shadow:
    0px 6px 12px 0px rgba(66, 79, 104, 0.06),
    0px 0px 4px 0px rgba(66, 79, 104, 0.08);
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1 1 calc(33% - 24px);
  max-width: calc(33% - 13px);
  min-width: 324px;
`;

export const DesignThumbnailWrapper = styled.div`
  width: 100%;
  height: auto;
  height: 176px;
  border: 1px solid ${props => props.theme.colors.neutral[20]};
  border-radius: 8px;
  overflow: hidden;
  position: relative;

  &:hover .overlay {
    opacity: 1;
    pointer-events: all;
  }
`;

export const DesignThumbnailOverlay = styled.div`
  display: flex;
  justify-items: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(39, 42, 50, 0.8);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 3;
`;

export const DesignThumbnailActionWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const DesignThumbnail = styled.img`
  background-color: ${props => props.theme.colors.white[100]};
  display: block;
  width: 100%;
  height: 100%;
  object-fit: fill;
`;

export const DesignTitle = styled.h3`
  font-weight: 600;
  font-size: 20px;
  height: 48px;
  line-height: 24px;
  letter-spacing: 0px;
  margin: 0;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  white-space: normal;
  word-break: break-word;
`;

export const ButtonSwitchLabel = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0px;
`;

export const EmptySearchText = styled.div<{
  fontSize?: string;
  maxWidth?: string;
}>`
  max-width: ${({ maxWidth }) => maxWidth || '351px'};
  font-size: ${({ fontSize }) => fontSize || '22px'};
  line-height: 24px;
  letter-spacing: 0%;
  color: ${props => props.theme.colors.neutral[80]};
  font-weight: 400;
  text-align: center;
`;

export const EmptySearchWrapper = styled.div<{ minHeight?: string }>`
  display: flex;
  gap: 24px;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  min-height: ${({ minHeight }) => minHeight || '430px'};
`;

export const ActiveWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActiveCircle = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${props => props.theme.colors.success[100]};
  border-radius: 50%;
`;

export const InactiveCircle = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${props => props.theme.colors.neutral[60]};
  border-radius: 50%;
`;

export const ActiveText = styled.span`
  color: ${props => props.theme.colors.success[100]};
  font-size: 14px;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0px;
  text-transform: uppercase;
`;

export const InactiveText = styled.span`
  color: ${props => props.theme.colors.neutral[60]};
  font-size: 14px;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0px;
  text-transform: uppercase;
`;

export const LinkText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0px;
  text-transform: uppercase;
`;

export const SecondaryText = styled.span`
  color: ${props => props.theme.colors.neutral[60]};
  font-weight: 500;
  font-size: 14px;
  height: 16px;

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const EnhancedFlex = styled(Flex)`
  &:hover {
    color: ${props => props.theme.colors.neutral[80]};
  }
  color: ${props => props.theme.colors.neutral[100]};

  &:disabled {
    color: red;
  }
`;

// lp builder modal
export const HorizontalMenu = styled.div`
  background-color: ${props => props.theme.colors.secondary[5]};
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
  height: 80px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const Sidebar = styled.div`
  width: 235px;
  height: 100%;
  background-color: ${props => props.theme.colors.secondary.non_alpha};
  padding: 24px 20px 0 20px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const SidebarItem = styled.div<SidebarItemProps>`
  display: flex;
  align-items: center;
  gap: 12px;

  height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.colors.secondary[5]};
  }

  ${props =>
    props.isActive &&
    css`
      background-color: ${props => props.theme.colors.secondary[10]};
    `}

  .lp-sidebar-icon {
    color: ${({ theme }) => theme.colors.secondary[100]};
    opacity: ${({ isActive }) => (isActive ? 1 : 0.6)};
    transition:
      opacity 0.2s ease,
      color 0.2s ease;
  }

  &:hover .lp-sidebar-icon {
    opacity: 1;
  }
`;
export const ControlContainer = styled.div`
  height: calc(100vh - 149px);
  overflow-y: auto;

  width: 100%;
  max-width: 327px;

  padding: 24px 20px 100px 20px;
  box-sizing: border-box;
  border-right: 1px solid ${props => props.theme.colors.neutral[20]};

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background-color: ${props => props.theme.colors.neutral[20]};
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${props => props.theme.colors.neutral[40]};
  }
`;
